import styled from "styled-components";
import { useConfig } from "./ConfigProvider";
import CheckMark from "./CheckMark";
import { useTunnelData } from "./TunnelContext";

import "./Choice.scss";
import Button from "./Button";

export default function Choice({ value, selected, onSelect, useImage = false, imageBaseURL, choiceType }) {
  const config = useConfig();
  const { tunnel } = useTunnelData();

  // Mapping des informations venues du backoffice VEL
  const name = value.vel_datas.name;
  const sub1 = value.vel_datas.sub1;
  const sub2 = value.vel_datas.sub2;
  const sub3 = value.vel_datas.sub3;
  const bullets = Array.from({ length: 10 }, (_, i) => value.vel_datas[`bullets_${i}`]);
  const pictos = Array.from({ length: 10 }, (_, i) => value.vel_datas[`pictos_${i}`]);

  const found = selected.find((f) => f["@id"] === value["@id"]);
  const isSelected = !!found;
  const mandatory = isSelected && !!found.mandatory;
  const onClick = (e) => {
    if (mandatory || !onSelect) return;
    onSelect(value);
  };

  if (useImage && (tunnel.club?.imageBaseURL || imageBaseURL) && value?.properties?.thumbnailImage?.publicId) {
    const img = `${tunnel.club?.imageBaseURL || imageBaseURL}${value.properties.thumbnailImage.publicId}`;

    // Just img in full size in the card, no text
    if (useImage === "withoutText") {
      return (
        <StyledArticle
          selected={isSelected}
          className={`OptionPreview ${value.topOffer ? "topOffer" : ""}`}
          config={config.choice}
          onClick={(e) => {
            e.preventDefault();
            onClick();
          }}
        >
          <img src={img} alt={(name || "").slice(0, 10)} />

          <div className="footer-choice" onClick={(e) => { e.stopPropagation(); if (!e.target.closest("label")) onClick(); }}>
            {!mandatory && onSelect && (
              <label>
                <input checked={isSelected} type="checkbox" onChange={onClick} />
                <span>
                  {isSelected
                    ? config.choice.selectedLabel
                    : config.choice.selectLabel}
                </span>
              </label>
            )}
            {!!mandatory && onSelect && (
              <label>
                <span>{config.choice.mandatoryLabel}</span>
              </label>
            )}
          </div>
        </StyledArticle>
      );
    }

    return (
      <StyledArticle
        selected={isSelected}
        className={`OptionPreview ${value.topOffer ? "topOffer" : ""}`}
        config={config.choice}
        onClick={(e) => {
          e.preventDefault();
          onClick();
        }}
      >
        <header style={{ textAlign: "center" }}>
          <h3>{name}</h3>
          <div className="optionPreviewPrice">
            <strong>{sub1}</strong>
            <strong>{sub2}</strong>
            {sub3 && <strong>{sub3}</strong>}
          </div>
        </header>
        <section style={{ display: "flex", flexGrow: 1 }}>
          <img src={img} alt={(name || "").slice(0, 10)} style={{ paddingBottom: "1rem" }} />
          {useImage !== "only" && (
            <ul>
              {bullets
                .filter((e) => e)
                .map((d, i) => {
                  const hasPictos = pictos[i] !== "" && pictos[i] !== undefined;
                  return (
                    <li key={i} style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                      {!hasPictos && <CheckMark />}
                      {hasPictos && (
                        <img
                          src={`/${pictos[i]}`}
                          alt={pictos[i].split(".")[0]}
                          className="OptionPreviewPicto"
                          style={{ marginRight: "16px", height: "24px" }}
                        />
                      )}

                      <span style={{ textAlign: "left" }}>{d.trim()}</span>
                    </li>
                  );
                })}
            </ul>
          )}
        </section>
        <div className="footer-choice" onClick={(e) => { e.stopPropagation(); if (!e.target.closest("label")) onClick(); }}>
          {!mandatory && onSelect && (
            <label>
              <input checked={isSelected} type="checkbox" onChange={onClick} />
              <span>{isSelected ? config.choice.selectedLabel : config.choice.selectLabel}</span>
            </label>
          )}
          {!!mandatory && onSelect && (
            <label>
              <span>{config.choice.mandatoryLabel}</span>
            </label>
          )}
        </div>
      </StyledArticle>
    );
  }

  const hasCustomSubClass = config?.plans?.customConfig && config?.plans?.customConfig?.isIncluded(tunnel.club);

  return (
    <StyledArticle
      selected={isSelected}
      className={`OptionPreview ${value.topOffer ? "topOffer" : ""}`}
      config={config.choice}
      onClick={(e) => {
        e.preventDefault();
        onClick();
      }}
    >
      <header style={{ textAlign: "center" }}>
        <h3>{choiceType === 'offers'
          ? (typeof config?.plans?.formatName === 'function'
            ? config?.plans?.formatName(name)
            : name)
          : name}
        </h3>
        <div className="optionPreviewPrice">
          <strong>{sub1}</strong>
          {hasCustomSubClass ? (
            <>
              <span className={config?.plans?.customConfig?.subClass}>{sub2}</span>
              {sub3 && <span className={config?.plans?.customConfig?.subClass}>{sub3}</span>}
            </>
          ) : (
            <>
              <strong>{sub2}</strong>
              {sub3 && <strong>{sub3}</strong>}
            </>
          )}
          <div className="separator" />
        </div>
      </header>
      <section>
        {choiceType === 'offers' && config.plans.buttonTitle && (
          <Button className="planButton">{config.plans.buttonTitle}</Button>
        )}
        <ul className="bullets">
          {bullets
            .filter((e) => e)
            .map((d, i) => {
              const hasPictos = pictos[i] !== "" && pictos[i] !== undefined;
              const firstBoldTitleOfc = i === 0 && pictos[0] === 'empty.svg' && (window.location.host.startsWith('pass.onefitnessclub.') || window.location.host.startsWith('pass-onefitnessclub-preprod'))
              return (
                <div key={i}>
                  <li style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                    {!hasPictos && <CheckMark />}
                    {hasPictos && (
                      <img
                        src={`/${pictos[i]}`}
                        alt={pictos[i].split(".")[0]}
                        className="OptionPreviewPicto"
                        style={{ marginRight: "16px", height: "24px" }}
                      />
                    )}
                    <span style={{ textAlign: "left", fontWeight: firstBoldTitleOfc && 'bold', marginRight: firstBoldTitleOfc && '-14px' }} >{d.trim()}</span>
                  </li>
                    {i === 0 && pictos[0] === 'empty.svg' && <img src='/ofc/add.svg' width={14} height={14} alt="add" className="add-ofc" />}
                </div>
              );
            })}
        </ul>
        {value.offer && (
        <div className="registrationFeeOfc" style={{marginTop: 'auto', paddingTop: "16px"}}>
          <p>
           Frais d'inscription web : {(value.offer.registrationFeeTI / 100).toFixed(2)} €
          </p>
        </div>
      )}
      </section>
      {((choiceType === 'offers' && !config.plans.buttonTitle && onSelect) || (choiceType === 'options' && onSelect)) && (
        <div className="footer-choice" onClick={(e) => { e.stopPropagation(); if (!e.target.closest("label")) onClick(); }}>
          {!mandatory && (
            <label>
              <input checked={isSelected} type="checkbox" onChange={onClick} />
              <span>{isSelected ? config.choice.selectedLabel : config.choice.selectLabel}</span>
            </label>
          )}
          {!!mandatory && (
            <label>
              <span>{config.choice.mandatoryLabel}</span>
            </label>
          )}
        </div>
      )}
    </StyledArticle>
  );
}

const StyledArticle = styled.article`
  background-color: ${(props) => props.config?.background || "white"};
  border: ${(props) =>
    props.selected
      ? `2px solid ${props.config?.border_selected || "red"}`
      : `2px solid ${props.config?.border || "green"}`};
  > header {
    h3 {
      color: ${(props) => props.config?.nameColor || "#e63f49"};
    }
  }
  > footer {
    background-color: ${(props) =>
      props.selected ? props.config?.footerBg || "yellow" : props.config?.footerBg_selected || "red"};
  }

  input {
    background-color: ${(props) => (props.selected ? props.config?.checkboxSelected || "black" : "")};
  }
`;
